<template>
  <div>
    <navbar :color="headerImage"
      @goto-content="scrollToContent($event)"
    >
    </navbar>
    <home v-if="headerImage" :strapi="strapi[0]"></home>

    <div class="container mt-10">
       <div class="row">
         <div class="col-12">  
    <div class="imprint">
       <div v-html="strapi[1].text">
       </div>
    </div>
        </div>
      </div>
    </div>
    <client-only>
      <footer-component :strapi="strapi[0]" id="contact"></footer-component>
    </client-only>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  components: {
    Navbar: () => import('@/components/Navbar'),
    Home: () => import('@/components/Home'),
    FooterComponent: () => import('@/components/FooterComponent'),
  },
  head: {
    title: process.env.company + ' | Disclaimer',
    /*meta: [
      {
        hid: 'description1',
        name: 'description2',
        content: 'Home page description'
      }
    ],*/
  },
  async asyncData({ params, $http }) {
      const strapi1 = await $http.$get(`http://localhost:1338/disclaimer`)
      const strapi2 = await $http.$get(`http://localhost:1338/strapisource`)

      return {strapi: [strapi2,strapi1]};
  },
  data(){
     return {
       jumpId: '',
       headerImage: false
     }
  },
  methods: {
    scrollToContent(id) {

      this.jumpId = id;
      this.$router.push({path : '/',name: 'index',params: {newid: id}});

    }
  }
}
</script>

<style scoped>
   @media only screen and (max-width: 600px) {
     .imprint {
       margin-top:35px;
     }
   }
   @media only screen and (min-width: 601px) {
     .imprint {
       margin-top:30px;
     }
   }

   .text-grey {
    color: #757575 !important;
   }

</style>

